import CelebrateScatterCommand from "commands/celebrate-scatter-command";
import { DimSymbolsCommand } from "slotworks/commands/symbols/dim-symbols-command";
import Components from "slotworks/components/components";
import { FadeOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { CenterPivot, PIXIElement } from "slotworks/graphics/pixi/group";
import gameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import soundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import Point from "slotworks/utils/geom/point";
import { parallel, sequence } from "slotworks/utils/race-utils";
import * as TweenJS from "slotworks/utils/tween";
import BonusBuyTransitions from "./bonus-buy-transitions";
import HarleyComponents from "components/components";

export default class FreespinsRetriggerTransitions extends BonusBuyTransitions {

    public readonly ZOOM_TIME = 600;

    // freespins_title, value
    public in(): Contract<void> {
        Layers.CelebrationBackground.getSprite("filter").visible = false;

        soundManager.customEvent("free_spins_retrigger");
        const value = Layers.Prompts.getText("value");
        const title = CenterPivot(Layers.Prompts.getSprite("freespins_title"), undefined, new Point(0.6, 0));
        value.scale.set(0, 0);
        title.scale.set(0, 0);
        return parallel([
            () => CelebrateScatterCommand(),
            () => this.startStacks(),
            () => this.zoomSpriteIn(value, 500),
            () => this.zoomSpriteIn(title, 500, 200)
        ]);
    }

    private zoomSpriteIn(element: PIXIElement, time: number, delay: number = 0) {
        return new Contract(resolve => {
            new TweenJS.Tween(element.scale)
                .to({ x: 1, y: 1 }, time)
                .easing(TweenJS.Easing.Back.Out)
                .delay(delay)
                .onComplete(() => resolve(null))
                .start();
        });
    }

    public out(): Contract<void> {
        return new Contract<void>(resolve => {

            for (let tween of this.glowTweens) {
                tween.stop();
            }
            this.glowTweens.length = 0;
            const title = Layers.Prompts.getSprite("freespins_title");

            // soundManager.customEvent("plaque_exit");

            parallel([
                () => this.moveValue(),
                () => FadeOut(title, 400),
                () => FadeOut(Layers.CelebrationBackground.container, 400),
                () => this.stopStacks(),
            ]).then(resolve);
        })
    }

    private moveValue() {
        return new Contract<void>(resolve => {
            const value = Layers.Prompts.getSprite("value");
            const target = Layers.Prompts.getPosition("target");

            new TweenJS.Tween(value.scale)
                .to({ x: 0.6, y: 0.6 }, 600)
                .start();

            new TweenJS.Tween(value)
                .to({ x: target.x, y: [value.y - 300, target.y] }, 660)
                .interpolation(TweenJS.Interpolation.Bezier)
                .onComplete(() => {
                    value.visible = false;
                    const record = gameState.getCurrentGame().getCurrentRecord() as FreespinRecord;
                    HarleyComponents.freespinsMeter.countUp(record.totalFreespins).then(resolve)
                })
                .start();
        });
    }
}